import { CompartmentCard } from "@/src/components/cards";
import Loading from "@/src/components/loading";
import { UploadCards } from "@/src/components/uploadSpots";
import { Exam } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { formatDate, getItemId } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import { PatientIdentity } from "../patients/patientIdentity";

export default function AnapathInfoCompartment({ exam }: { exam: Exam }) {
  const [reload, setReload] = useState(0);
  const [searchKey, setSearchKey] = useState<string | null>(null);
  const {
    data: appointment,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ["AnapathAppointment", exam?.id, reload],
    queryFn: async () =>
      apiFetch("appointments", "loadOne", {
        itemId: getItemId(exam),
        patientId: getItemId(exam?.patient),
      }),
  });

  return (
    <div>
      <div className="c1 gap20">
        <div className="c1 ">
          {isLoading && <Loading size={30} />}
          {isError && <div>Erreur: {error.message}</div>}
          {appointment && (
            <div className="mbottom10">
              <div className="bold">{appointment?.notes}</div>
              {appointment?.start != null && (
                <div className="tcenter gray">
                  {formatDate(appointment.start, "LL HH:mm")}
                </div>
              )}
              <FieldAnswersList
                patient={appointment?.patient}
                reference={appointment?.type?.demandForm}
                answers={appointment?.demandContent?.fieldAnswers || []}
              ></FieldAnswersList>
              <UploadCards uploads={appointment.uploads} count={3} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
